import { useQuery } from '@tanstack/react-query';
import { PulseLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

import { apiGet } from '../../services/_common';
import IssueGuide from '../IssueGuide';
import Slider from 'react-slick';
import { ERROR } from '../../_constants';
import { IUser } from '../../atoms';

const imageBoardSettings = {
  dots: true,
  dotsClass: 'slick-dots slick-thumb',
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 30000,
};

// 이미지 게시판
export const ImageBoard = ({ name, userInfo, refetchInterval }: { name: string; userInfo: IUser; refetchInterval: number }) => {
  const { hCd, sCd } = userInfo;
  const { t } = useTranslation();
  const {
    data: siteImageBoardData,
    isLoading,
    isError,
  } = useQuery(['siteImageBoardGet', userInfo], () => fetchData(), {
    enabled: !!hCd && !!sCd && sCd !== '00000',
    ...(refetchInterval !== undefined && { refetchInterval }), // 30분
  });

  const fetchData = async () => {
    try {
      const res = await apiGet({ path: '/safe/imageboardcontents', req: { hCd, sCd } });
      if (res.status === 200) return res.data.data;
      return undefined;
    } catch (error) {
      console.error(error);
      throw new Error('error');
    }
  };

  const loading = isLoading || !siteImageBoardData;

  if (isError) return <IssueGuide type='error' text={ERROR} />;
  if (loading) {
    return (
      <div className='centered-content'>
        <PulseLoader color='rgb(0, 122, 255)' size='10px' />
      </div>
    );
  }

  return (
    <div className='imageBoard'>
      {/* <div className='widget-header'>
        <div className='widget-title flex-between '>
          <span>{t(name)}</span>
        </div>
      </div> */}
      <div className='content'>
        <Slider {...imageBoardSettings}>
          {siteImageBoardData?.imageBoardTList?.map((el: any, i: number) => (
            <img key={`${i}`} src={el.iFilename} alt='' />
          ))}
        </Slider>
      </div>
    </div>
  );
};
